export const appShadowRoot = document.querySelector('exl-support').shadowRoot;
export const $el = {
  app: appShadowRoot.querySelector('#app'),
  apps: Array.from(appShadowRoot.querySelectorAll('[data-id="apps"]')),
  dashboard: Array.from(appShadowRoot.querySelectorAll('a[href*="#dashboard/learning"]')),
  feedback: appShadowRoot.querySelector('dx-docs-feedback'),
  footer: appShadowRoot.querySelector('#footer'),
  html: appShadowRoot.querySelector('html'),
  launcher: appShadowRoot.querySelector('#launcher'),
  modal: appShadowRoot.querySelector('.modal'),
  modalImage: Array.from(appShadowRoot.querySelectorAll('img.modal-image')),
  modalContent: appShadowRoot.querySelector('.modal .modal-content'),
  mt: Array.from(appShadowRoot.querySelectorAll('dx-docs-mt')),
  navbar: appShadowRoot.querySelector('#nav'),
  navburger: appShadowRoot.querySelector('#nav .navbar-burger'),
  navmenu: appShadowRoot.querySelector('#nav .navbar-menu'),
  navend: appShadowRoot.querySelector('#nav .navbar-menu .navbar-end'),
  next: appShadowRoot.querySelector('a[data-id="next"]'),
  notice: appShadowRoot.querySelector('.spectrum-Toast'),
  noticeContent: appShadowRoot.querySelector('.spectrum-Toast .spectrum-Toast-content'),
  noticeIcon: appShadowRoot.querySelector('.spectrum-Toast #toast-icon'),
  noticeBtn: appShadowRoot.querySelector('.spectrum-Toast #dismiss'),
  noticeIconUse: appShadowRoot.querySelector('.spectrum-Toast #toast-icon use'),
  noticeIconImg: appShadowRoot.querySelector('.spectrum-Toast #toast-icon img'),
  other: appShadowRoot.querySelector('div[data-id="other"]'),
  promo: appShadowRoot.querySelector('div[data-id="promo-container"]'),
  search: appShadowRoot.querySelector('#rsearch'),
  sidead: appShadowRoot.querySelector('div[data-id="sidead"]'),
  spectrumNotice: appShadowRoot.querySelector('[data-id="spectrum-notice-container"]'),
  support: appShadowRoot.querySelector('#support'),
};

export function noscroll(arg, enable = true) {
  const klass = 'no-scroll';

  arg?.classList[enable ? 'add' : 'remove'](klass);
}
